import { reportingApi } from './reportingApiBase';
import { FacilityReportSummaryView, FacilityCenterBreakdownView, FacilityIssueTypeBreakdownView, FacilityReportFilters } from './types';

export const facilityReportQueriesApi = reportingApi.injectEndpoints({
  endpoints: (builder) => ({
    getFacilitySummary: builder.query<FacilityReportSummaryView, FacilityReportFilters>({
      query: (filters) => ({
        url: 'tickets/facility/summary',
        params: {
          centerId: filters.centerId,
          issueType: filters.issueType,
          fromDate: filters.fromDate,
          toDate: filters.toDate,
        },
      }),
      providesTags: ['FacilityReport'],
    }),

    getFacilityByCenter: builder.query<FacilityCenterBreakdownView[], FacilityReportFilters>({
      query: (filters) => ({
        url: 'tickets/facility/by-center',
        params: {
          centerId: filters.centerId,
          issueType: filters.issueType,
          fromDate: filters.fromDate,
          toDate: filters.toDate,
        },
      }),
      providesTags: ['FacilityReport'],
    }),

    getFacilityByIssueType: builder.query<FacilityIssueTypeBreakdownView[], FacilityReportFilters>({
      query: (filters) => ({
        url: 'tickets/facility/by-issue-type',
        params: {
          centerId: filters.centerId,
          issueType: filters.issueType,
          fromDate: filters.fromDate,
          toDate: filters.toDate,
        },
      }),
      providesTags: ['FacilityReport'],
    }),
  }),
});

export const {
  useGetFacilitySummaryQuery,
  useGetFacilityByCenterQuery,
  useGetFacilityByIssueTypeQuery,
} = facilityReportQueriesApi;
